<script setup lang="ts">
  import type { PropType } from 'vue';
  import type { Photo } from '@storefront/resources';

  defineProps({
    photos: { type: Array as PropType<Photo[]>, required: true },
    link: String,
  });
</script>
<template>
  <section v-if="photos.length > 0" class="banner-block">
    <MediaPicture :photo="photos[0]" type="background" class="" sizes="2800x800 2x min 992, 1400x400 min 992, 1984x568 2x min 576, 992x284 min 576, 1152x330 2x, 576x165" />
    <a v-if="link" :href="link" class="banner-block__link" />
  </section>
</template>
<style scoped lang="scss">
  @use '@storefront/styles/mixins/media' as media;

  .banner-block {
    position: relative;

    &__link {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }

    :deep(picture) {
      width: 100%;

      img {
        object-fit: cover;
        aspect-ratio: 7/2;
        width: 100%;
        border-radius: var(--border-radius);

        @include media.query(lg) {
          border-radius: 0;
        }
      }
    }
  }
</style>
